import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import "../../styles/AdminHome.css"; // Import the CSS file for styling
import axios from "axios";
import BASE_URL from "../../BaseUrl";
import Notifications from "../admin/Notifications";
import MenuLogo from "../../menu logo.svg";
import { useEffect, useState, useContext } from "react";
import {GlobalContext} from "../GlobalContext";

export default function NavBare({active, setActive, mobileActive, setMobileActive}) {
    const navigate = useNavigate();
    const [indicatorStyle, setIndicatorStyle] = useState({});
    const {admin} = useContext(GlobalContext);
    const navRefs = useRef({});
    const [loaded , setLoaded] = useState(false);
    const [mobileSideMenu, setMobileSideMenu] = useState(false);
    const [newNotifications, setNewNotifications] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [checkNotifications, setCheckNotifications] = useState(false);
  const menuRef = useRef(null);
    const logout = () =>{
        axios.get(`${BASE_URL}/assistant/logout`,{withCredentials:true})
        .then((response)=>{
            navigate("/")
        }).catch((error)=>{
            console.log(error);
            navigate("/")
        })
    }

    useEffect(()=>{
        if(admin === null || admin === undefined){
            navigate("/");
        }
        setLoaded(true);
        const current = navRefs.current[active];
    if (current) {
      setIndicatorStyle({
        left: current.offsetLeft + "px",
        top: current.offsetTop + current.offsetHeight + "px",
        width: current.offsetWidth + "px",
        height: "1px",
      });
    }

    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMobileSideMenu(false);
      }    
  }
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);

  return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
    }
    },[active,admin,navigate])

    useEffect(()=>{
        const repeat = () => {
            axios.get(`${BASE_URL}/assistant/check-notifications`,{withCredentials:true})
                .then((response)=>{
                    setNewNotifications(response.data);
                }).catch((error)=>{
                    console.log(error);
                });
            setTimeout(repeat, 600000); // repeat every tens minute
        };
        repeat();
    },[active,checkNotifications])
    return (
        <div>

          {showNotifications &&
              <div className="notifications-overlay" >
                  <div className="side-notifications"
                  >
                      <Notifications setCheckNotifications={setCheckNotifications} checkNotifications={checkNotifications} setShowNotifications={setShowNotifications} isAdmin={false}/>
                  </div>
              </div>
          }
            {loaded&&(<div className='admin-nav'>
            <div className="indicator" style={indicatorStyle}></div>
                <button 
                    ref={(el) => (navRefs.current["تسجيل الخروج"] = el)}
                    className='admin-home-nav-button' onClick={() => {
                        setActive("تسجيل الخروج");
                        setTimeout(()=>{logout();},200)}}>تسجيل الخروج</button>
                <button ref={(el) => (navRefs.current["المواد الدراسية"] = el)} className={` admin-home-nav-button`} onClick={() => {
                    setActive("المواد الدراسية");setTimeout(()=>{navigate("/assistant-home",{state:{admin:admin}});},200)
                    }}>المواد الدراسية</button>
                <button ref={(el) => (navRefs.current["الملف الشخصي"] = el)} className={` admin-home-nav-button`} onClick={() => {
                    setActive("الملف الشخصي");setTimeout(()=>{navigate("/assistant-home/assistant-profile",{state:{admin:admin}});},200)
                }}>الملف الشخصي</button>
                <button className={`admin-home-nav-button`} onClick={() => {
                    setShowNotifications(true);
                }}>الإشعارات
                    <span className={`notif-dot ${newNotifications? "new":""}`}></span>
                </button>
                <h1 style={{direction: "rtl",unicodeBidi: "embed"}}>مرحبا {admin.name}</h1>
            </div>)}

            {loaded&&(
                <div className={`${mobileSideMenu? "overlay": ""}`}>
                
                <div className='mobile-admin-nav' ref={(el)=>{menuRef.current = el}}>
                <img className={`menu-logo ${mobileSideMenu? "opened": ""}`} src={MenuLogo} alt="no" onClick={
                    (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setMobileSideMenu(!mobileSideMenu)}
                    
                    }/>
                {mobileSideMenu&&(
                    
                    <div  className="mobile-log-in-nav-buttons">
                <button 
                    ref={(el) => (navRefs.current["تسجيل الخروج mobile"] = el)}
                    className={`admin-home-nav-button`} onClick={() => {
                        setMobileActive("تسجيل الخروج mobile");
                        setMobileSideMenu(false);
                        setTimeout(()=>{logout();},200)}}>تسجيل الخروج</button>
                <button ref={(el) => (navRefs.current["المواد الدراسية mobile"] = el)} className={` ${mobileActive==="courses mobile"? "mobile-active ": ""} admin-home-nav-button`} onClick={() => {
                    setMobileSideMenu(false);setMobileActive("courses mobile");setTimeout(()=>{navigate("/assistant-home",{state:{admin:admin}});},200)
                    }}>المواد الدراسية</button>
                <button ref={(el) => (navRefs.current["الملف الشخصي mobile"] = el)} className={`${mobileActive === "profile mobile"? "mobile-active ": ""} admin-home-nav-button`} onClick={() => {
                    setMobileSideMenu(false);setMobileActive("profile mobile");setTimeout(()=>{navigate("/assistant-home/assistant-profile",{state:{admin:admin}});},200)
                }}>الملف الشخصي</button>
                <button className={`admin-home-nav-button`} onClick={() => {
                    setMobileSideMenu(false);
                    setShowNotifications(true);
                }}>الإشعارات
                    <span className={`notif-dot-mobile ${newNotifications? "new":""}`}></span>
                </button>
                </div>
                )}
                <h1>مرحبا {admin.name}</h1>
            </div>
            </div>
            
            )}
        </div>
    );
}